import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Configuration } from 'config/config';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ICompany } from 'app/shared/Domains/company';
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";



 @Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.css']
})
export class PublicHeaderComponent {

  @Input() company: string;
  @Input() branch: string;
 companies : ICompany;
 selectedCompany: any;
  
  constructor(private route: ActivatedRoute, public config: Configuration,
        private appServiceManager: AppServiceManager,private messageService: MessageService,) { }

  ngOnInit(): void {
    this.companies = new ICompany();
    this.getCompanyById();
  }
  getCompanyById() {
    this.appServiceManager.get('companies/' + this.company).subscribe(
      (res) => {
        if (res) {
          this.selectedCompany= res;
        } else {
          this.companies = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.companies = new ICompany();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }



}